import { useSelector } from 'react-redux';
import TopMenu from '../TopMenu/TopMenu';
import Visualizer from '../Visualizer/Visualizer';
import ProductMenu from '../ProductMenu/ProductMenu';
import ShareModal from '../ShareModal/ShareModal';
import EmailShareModal from '../EmailShareModal/EmailShareModal';
import ProjectsModal from '../ProjectsModal/ProjectsModal';
import HelpModal from '../HelpModal/HelpModal';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import ZoomModal from '../ZoomModal/ZoomModal';
import styles from './VisualizerPage.module.css';
import useCompare from '../Compare/useCompare'; 

export default function VisualizerPage() {
    const shareModalStatus = useSelector(state => state.ui.shareModalActive);
    const emailModalStatus = useSelector(state => state.ui.emailModalActive);
    const projectsModalStatus = useSelector(state => state.ui.projectsModalActive);
    const helpModalStatus = useSelector(state => state.ui.helpModalActive);
    const feedbackModalStatus = useSelector(state => state.ui.feedbackModalActive);
    const zoomModalStatus = useSelector(state => state.ui.zoomModalActive);

    const {
        containerRef,
        afterWrapperRef,
        sliderRef,
        setIsDragging,
        handleCompareToggle,
        handleCompareSideChange,
        applyCompareSide
    } = useCompare();

    return (
        <>
            <TopMenu extended page="visualizer" />
            <section className={styles.visualizerView}>
                <div className={styles.visualizerContainer}>
                    <Visualizer
                        handleCompareToggle={handleCompareToggle}
                        applyCompareSide={applyCompareSide}
                        handleCompareSideChange={handleCompareSideChange}
                        containerRef={containerRef}
                        afterWrapperRef={afterWrapperRef}
                        sliderRef={sliderRef}
                        setIsDragging={setIsDragging}
                    />
                </div>
                <div className={styles.productMenuContainer}>
                    <ProductMenu/>
                </div>
            </section>

            {shareModalStatus && <ShareModal />}
            {emailModalStatus && <EmailShareModal />}
            {projectsModalStatus && <ProjectsModal />}
            {helpModalStatus && <HelpModal />}
            {feedbackModalStatus && <FeedbackModal />}
            {zoomModalStatus && <ZoomModal />}
        </>
    );
}
